module.exports = __webpack_public_path__ + "img/top_action.05b37607.jpg";